const __xstack = [] //single instance of loading stack
// Prefer Overlay2 (corner indicator); fall back to legacy fullscreen overlay.
const LOADING_CLAZZ = 'loading'
const HIDE_CLAZZ = 'loading-hide'
const LOADING2_CLAZZ = 'loading2'
const HIDE2_CLAZZ = 'loading2-hide'

export class LoadingOverlayService {
    constructor() {
        this.stack = __xstack;
    }
    put(v) {
        this.stack.push(v)
        this.loadingState()
    }
    pop() {
        if (this.size() === 0) return 0
        let v = this.stack.shift()
        this.loadingState()
        return v
    }
    size() {
        return this.stack && this.stack.length
    }
    loadingState() {
        const el2 = document.querySelector('.x-indicator2')
        const el = el2 || document.querySelector('.x-indicator')
        const loadingClazz = el2 ? LOADING2_CLAZZ : LOADING_CLAZZ
        const hideClazz = el2 ? HIDE2_CLAZZ : HIDE_CLAZZ
        if (el && el.classList) {
            if (this.size() > 0) {
                if (el.classList.contains(hideClazz)) {
                    el.classList.remove(hideClazz)
                }
                if (!el.classList.contains(loadingClazz)) {
                    el.classList.add(loadingClazz)
                }
            } else {
                if (el.classList.contains(loadingClazz)) {
                    el.classList.remove(loadingClazz)
                }
                if (!el.classList.contains(hideClazz)) {
                    el.classList.add(hideClazz)
                }
            }
        }
    }
}

export const loadingOverlayService = new LoadingOverlayService();
